import { ResolveFn } from "@angular/router";
import { inject } from "@angular/core";
import { ChatApiService } from "@app/shared/chat/services/chat-api.service";
import { IChatMessage, IPaginatedChatMessage } from "@app/shared/chat/interfaces/chat-message.interface";
import { map } from "rxjs";

export const getChatMessagesResolver: ResolveFn<IChatMessage[]> = (route, _state) => {
  const chatApiService = inject(ChatApiService);

  // Fetch the area ID from the route's parameter map
  const swapRequestId = route.paramMap.get("conversationId");

  if (!swapRequestId) {
    throw new Error(`Route param '${swapRequestId}' is missing or undefined`);
  }

  // Fetch the area data from the API service using the id and optional dataShape
  return chatApiService.getChatMessages(swapRequestId).pipe(map((chatMessages: IPaginatedChatMessage) => chatMessages.data));
};
